import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";

import { AccountType } from "users/account-types/account-type";
import Guid from "_shared/guids/guid";
import VendorTeamName from "work/work-agreements/teams/vendor-team/vendor-team-name/vendor-team-name";
import EntityMemberCommand from "_shared/entity-members/_api/commands/entity-member-api-command";

export default class TeamTemplateAPIRequest {
  entityId?: string;
  name?: string;
  leader?: EntityMemberCommand;
  members?: EntityMemberCommand[];
  creatorType?: string;
  marketplaceId?: string;

  constructor(
    entityId: Guid,
    team: VendorTeam,
    name: VendorTeamName,
    creatorType: AccountType,
    marketplaceId?: Guid
  ) {
    this.entityId = entityId.value;
    this.name = name.value;
    this.leader = team.leader ? new EntityMemberCommand(team.leader) : undefined;
    this.members = team.members.map(member => new EntityMemberCommand(member));
    this.creatorType = creatorType;
    this.marketplaceId = marketplaceId?.value;
  }
}